;(function($) {
	$.fn.shopgateUICheckbox = function(options) {
		var defaults = {
			onChange: function(checkbox, isManual){},
			disable: false
		};

		options = $.extend(true, {}, defaults, options);

		return this.each(function(){

			var that = $(this),
				iosCheckbox = $('<div>', {class: 'sg-ios-checkbox'}).append($('<div>', {class: 'inner'})),
				checkboxDisabled = false;

			// remove old uiCheckboxes that are related to the current browser checkbox
			if (that.next().hasClass('sg-ios-checkbox')) {
				that.next().remove();
			}

			// transfer the checkbox state to the iOS checkbox
			if (that.is(':checked')) {
				iosCheckbox.addClass('checked');
			}

			// transfer the disable state from the options to the checkbox
			_toggleDisabledState(options.disable);

			// hide the checkbox and add the iOS checkbox to the DOM
			that.hide().after(iosCheckbox);

			// add some event listeners
			iosCheckbox.bind('click', function(){
				_toggleCheckedState(!that.is(':checked'), true);
			});

			that.bind('updateState', function(e, checked){
				_toggleCheckedState(typeof checked == 'boolean' ? checked : that.is(':checked'));
			}).bind('change', function(){
				_toggleCheckedState($(this).is(':checked'), true);
			}).bind('disable', function(e, disabled){
				_toggleDisabledState(disabled);
			});

			/**
			 * Toggles the checked state of the checkbox
			 * @param  {Boolean} state    The requested state
			 * @param  {Boolean} isManual Indicates if the state toggle was triggered by a user interaction
			 */
			function _toggleCheckedState(state, isManual) {
				// do nothing if the checkbox is disabled
				if (isManual && checkboxDisabled) {return false;}

				// assign the state to the checkbox and the iOS checkbox
				that.prop('checked', state);
				iosCheckbox.toggleClass('checked', state);

				// trigger the onChange events
				_callOnChangeEvent(isManual);
			}

			/**
			 * Toggles the disabled state of the checkbox
			 * @param  {Boolean} state The requested state
			 */
			function _toggleDisabledState(state) {
				state = typeof state == 'boolean' ? state : true;

				checkboxDisabled = state;

				// assign the state to the checkbox and the iOS checkbox
				that.prop('disabled', state);
				iosCheckbox.toggleClass('disabled', state);
			}

			/**
			 * Calls the onChange events
			 * @param  {Boolean} isManual Indicates if the state toggle was triggered by a user interaction
			 */
			function _callOnChangeEvent(isManual) {
				options.onChange(that, (typeof isManual == 'boolean' ? isManual : false));
				that.trigger('onChange', [that, (typeof isManual == 'boolean' ? isManual : false)]);
			}
		});
	};
})(jQuery);


// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-ui-checkbox.js